export default {
    topics: [
        {
            title: ' content ',
            href: 's-ncm-content.html',
            attributes: { 'data-id': 's-ncm-content' },
            menu: { hasChildren: false },
            tocID: 's-ncm-content-d66e1989',
            next: 's-ncm-content-d66e1989',
        },
        {
            title: ' publishing ',
            href: 's-ncm-publishing.html',
            attributes: { 'data-id': 's-ncm-publishing' },
            menu: { hasChildren: false },
            tocID: 's-ncm-publishing-d66e2005',
            next: 's-ncm-publishing-d66e2005',
        },
    ],
};

